import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PersonalityStepperComponent} from './personality-stepper/personality-stepper.component';

const routes: Routes = [
  // {path: '', component: PersonalityStepperComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
